import {createContext, useReducer} from 'react';
import {convertCmToPxWithScaling} from "../services/helpers";

const initialWidthCm = 30; // Initial width in cm
const initialHeightCm = 30; // Initial height in cm
const initialScale = 0.5; // Initial scale factor for the working size

const initialState = {
    widthPx: convertCmToPxWithScaling(initialWidthCm, initialScale),
    heightPx: convertCmToPxWithScaling(initialHeightCm, initialScale),
    widthCm: initialWidthCm,
    heightCm: initialHeightCm,
    scale: initialScale
};

export const WorkingSizeContext = createContext(null);
export const WorkingSizeDispatch = createContext(null);

function workingSizeReducer(state, action) {

    switch (action.type) {
        case 'setWorkingSize':
            return {
                ...state,
                scale: action.payload.scale,
                widthCm: action.payload.widthCm,
                heightCm: action.payload.heightCm,
                widthPx: convertCmToPxWithScaling(action.payload.widthCm, action.payload.scale),
                heightPx: convertCmToPxWithScaling(action.payload.heightCm, action.payload.scale),
            };
        case 'setWorkingSizeCm':
            return {
                ...state,
                widthCm: action.payload.widthCm,
                heightCm: action.payload.heightCm,
                widthPx: convertCmToPxWithScaling(action.payload.widthCm, state.scale),
                heightPx: convertCmToPxWithScaling(action.payload.heightCm, state.scale),
            };
        case 'setScale':
            return {
                ...state,
                scale: action.payload.scale,
                widthPx: convertCmToPxWithScaling(state.widthCm, action.payload.scale),
                heightPx: convertCmToPxWithScaling(state.heightCm, action.payload.scale),
            };

        default:
            throw new Error(`Unknown action: ${action.type}`);
    }
}

export function WorkingSizeProvider({children}) {
    const [state, dispatch] = useReducer(workingSizeReducer, initialState);

    return (
        <WorkingSizeContext.Provider value={state}>
            <WorkingSizeDispatch.Provider value={dispatch}>
                {children}
            </WorkingSizeDispatch.Provider>
        </WorkingSizeContext.Provider>
    );
}